export const darkTheme = {
  colors: {
    primary: '#121214',
    secondary: '#ff9000',
    tertiary: '#202024',
    textPrimary: '#fafafa',
    textSecondary: '#bdbdbd',
    textTertiary: '#9e9e9e',
    bg: '#22262b',
    bgOpacity: 'rgba(1,1,1, 0.2)',
  },
};

export const lightTheme = {
  colors: {
    primary: '#f5f5f5',
    secondary: '#ff9000',
    tertiary: '#eee',
    textPrimary: '#212121',
    textSecondary: '#424242',
    textTertiary: '#757575',
    bg: '#fff',
    bgOpacity: 'hsla(0,0%,100%,0)',
  },
};
